import {useAppSelector} from "../../store/hooks";
import {ApplicationModalArray} from "./ApplicationModalArray";

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.mainLead);

    return isModalOpen ? <ApplicationModalArray /> : null;
}
import {useAppSelector} from "../../store/hooks";
import {ApplicationModalArray} from "./ApplicationModalArray";

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.mainLead);

    return isModalOpen ? <ApplicationModalArray /> : null;
}
